const state = {
   requestTypes: [
      {
         name: "Opt Out",
         url: "opt-out",
         namespace: "optOut",
         icon: "hand-paper"
      },
      {
         name: "Know",
         url: "request-to-know",
         namespace: "knowReq",
         icon: "question"
      },
      {
         name: "Delete",
         url: "request-to-delete",
         namespace: "deleteReq",
         icon: "trash-alt"
      }
   ],
   activeType: null
}

const getters = {
   getRequestTypes(state) {
      return state.requestTypes;
   },
   getActiveType(state) {
      return state.activeType;
   }
}

const actions = {
   startSetActiveType({ commit, state }, path) {
      const type = state.requestTypes.filter(type => {
         return type.url === path.split('/')[1];
      })[0];
      commit("SET_ACTIVE_TYPE", type)
   }
}

const mutations = {
   SET_ACTIVE_TYPE(state, type) {
      state.activeType = type;
   }
}

export default {
   state,
   getters,
   actions,
   mutations
}